import { Card, CardContent, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { cloneDeep } from "lodash";
import React, { useEffect, useState } from "react";
import { ICVRemovedMaterialInformationFormSection, IMaterial } from "../../interfaces";
import { FormSectionHeader } from "../Shared/FormSectionHeader";
import { MaterialConsumableTableRow } from "./MaterialConsumableTableRow";

export const RemovedMaterialInformationForm: React.FC<ICVRemovedMaterialInformationFormSection> = ({
    status,
    materials,
    consumedMaterials,
    onUpdateMaterials,
    onConsumeMaterials,
    onReinstateMaterial,
    readonly,
    saving,
    ...props
}: ICVRemovedMaterialInformationFormSection) => {

    useEffect(() => {

    }, [materials, readonly])


    const [consumed, setConsumed] = useState<string[]>(consumedMaterials ?? []);

    const consumeMaterial = (material: IMaterial, consume: boolean) => {

        let consumeList = cloneDeep(consumed);

        consumeList = consumeList.filter(x => x !== material.materialId);

        if (consume && material.materialId)
            consumeList.push(material.materialId);

        setConsumed(consumeList);
        onConsumeMaterials(consumeList);

    }

    const MaterialTableHead = () => {
        return (<TableHead>
            <TableRow>
                <TableCell>Description</TableCell>
                <TableCell>Vehicle Class</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Part Identification</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Qty</TableCell>
                <TableCell><strong>Consumed?</strong></TableCell>
                {!readonly && <TableCell />}
            </TableRow>
        </TableHead>);
    }



    return (
        <Card>

            <FormSectionHeader label="Materials to Remove" color="warning" saving={saving} />

            <CardContent>

                <Grid container spacing={4}>
                    {materials.length > 0 ?

                        <Grid item xs={12}>
                            <TableContainer>
                                <Table>
                                    <MaterialTableHead />

                                    <TableBody>
                                        {materials.length > 0 && materials.map((material, i) =>
                                            <MaterialConsumableTableRow
                                                key={i}
                                                material={material}
                                                readOnly={readonly}
                                                consumed={consumed}
                                                onConsume={(consume) => consumeMaterial(material, consume)}
                                                onUndo={() => onReinstateMaterial(material)}
                                            />
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid> : <br />}
                </Grid>
            </CardContent>
        </Card>
    );
}